export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";
export const ORDER_DETAILS = "ORDER_DETAILS";
export const REGISTER_DELIVERY_DETAILS = "REGISTER_DELIVERY_DETAILS";
export const REGISTER_DELIVERY_SUCCESS = "REGISTER_DELIVERY_SUCCESS";
export const REGISTER_DELIVERY_DETAILS_FAILED =
  "REGISTER_DELIVERY_DETAILS_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_DETAILS = "USER_DETAILS";
export const USER_DETAILS_BEGIN = "USER_DETAILS_BEGIN";
export const USER_DETAILS_ERROR = "USER_DETAILS_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_PRODUCTS_BEGIN = "GET_PRODUCTS_BEGIN";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";
export const GET_SINGLE_PRODUCT_BEGIN = "GET_SINGLE_PRODUCT_BEGIN";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_ERROR = "GET_SINGLE_PRODUCT_ERROR";
export const ADD_TO_CART = "ADD_TO_CART";
export const CLEAR_CART = "CLEAR_CART";
export const COUNT_CART_TOTALS = "COUNT_CART_TOTALS";
export const REMOVE_CART_ITEM = " REMOVE_CART_ITEM";
export const TOGGLE_CART_ITEM_AMOUNT = "TOGGLE_CART_ITEM_AMOUNT";
///VENDOR ACTIONS
export const REQUEST_VENDOR_LOGIN = "REQUEST_VENDOR_LOGIN";
export const LOGIN_VENDOR_SUCCESS = "LOGIN_VENDOR_SUCCESS";
export const LOGIN_VENDOR_ERROR = "LOGIN_VENDOR_ERROR";
export const VENDOR_LOGOUT = "VENDOR_LOGOUT";
export const VENDOR_DETAILS = "VENDOR_DETAILS";
export const VENDOR_DETAILS_BEGIN = "VENDOR_DETAILS_BEGIN";
export const VENDOR_DETAILS_ERROR = "VENDOR_DETAILS_ERROR";
export const REGISTER_VENDOR = "REGISTER_VENDOR";
export const REGISTER_VENDOR_SUCCESS = "RREGISTER_VENDOR_SUCCESS";
export const REGISTER_VENDOR_ERROR = "RREGISTER_VENDOR_ERROR";
export const CHANGE_VENDOR_PASSWORD = "CHANGE_VENDOR_PASSWORD";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const END_CREATE_PRODUCT = "END_CREATE_PRODUCT";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_ERROR = "CREATE_PRODUCT_ERROR";
export const GET_VENDOR_PRODUCTS = "GET_VENDOR_PRODUCTS";
export const GET_VENDOR_PRODUCTS_SUCCESS = "GET_VENDOR_PRODUCTS_SUCCESS";
export const GET_VENDOR_PRODUCTS_ERROR = "GET_VENDOR_PRODUCTS_ERROR";
export const GET_VENDOR_ORDERS = "GET_VENDOR_ORDERS";
export const GET_VENDOR_ORDERS_SUCCESS = "GET_VENDOR_ORDERS_SUCCESS";
export const GET_VENDOR_ORDERS_ERROR = "GET_VENDOR_ORDERS_ERROR";
export const GET_STATE = "GET_STATE";
export const GET_CITIES = "GET_CITIES";
